import { render, staticRenderFns } from "./PropertyListNew.vue?vue&type=template&id=41f01e19&scoped=true&"
import script from "./PropertyListNew.vue?vue&type=script&lang=js&"
export * from "./PropertyListNew.vue?vue&type=script&lang=js&"
import style0 from "./PropertyListNew.vue?vue&type=style&index=0&id=41f01e19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f01e19",
  null
  
)

export default component.exports